/** Durée en secondes → `MM:SS` (timer, lecteur). */
export function formatDurationSecondsClock(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
